// Tiny Meta Pixel helper. Pixel base script + init lives in /public/index.html.
// These wrappers safely no-op if fbq is not loaded (ad-blockers, etc.).

const safeFbq = (...args) => {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq !== 'function') return;
  try {
    window.fbq(...args);
  } catch (_) {
    /* swallow */
  }
};

export const fbTrack = (event, params) => safeFbq('track', event, params);
export const fbTrackCustom = (event, params) => safeFbq('trackCustom', event, params);

export const fbViewContent = ({ id, name, price, currency }) =>
  fbTrack('ViewContent', {
    content_ids: id ? [id] : undefined,
    content_name: name,
    content_type: 'product',
    value: price,
    currency,
  });

export const fbAddToCart = ({ id, name, price, currency, quantity = 1 }) =>
  fbTrack('AddToCart', {
    content_ids: id ? [id] : undefined,
    content_name: name,
    content_type: 'product',
    value: Number((Number(price) * Number(quantity)).toFixed(2)),
    currency,
    num_items: quantity,
  });

export const fbInitiateCheckout = ({ id, value, currency, quantity = 1, coupon }) =>
  fbTrack('InitiateCheckout', {
    content_ids: id ? [id] : undefined,
    content_type: 'product',
    value,
    currency,
    num_items: quantity,
    coupon,
  });

export const fbPurchase = ({ id, value, currency, quantity = 1 }) =>
  fbTrack('Purchase', {
    content_ids: id ? [id] : undefined,
    content_type: 'product',
    value,
    currency,
    num_items: quantity,
  });
